module.exports = __webpack_public_path__ + "static/img/RP-U24V6_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RP-U24V6_1.png
// module id = Xcbq
// module chunks = 0